// Custom
import empionLogoLight from '../../assets/sign_up_page/empion-logo-only-light.png';

export const getLogo = () => {
  return empionLogoLight;
};
